"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const MapRadiusSearch_styled_1 = require("./MapRadiusSearch.styled");
function PinOfInterest(props) {
    const { coordinates, name, iconName } = props;
    return (react_1.default.createElement(MapRadiusSearch_styled_1.PinItself, { coordinates: coordinates, object: {} },
        react_1.default.createElement(MapRadiusSearch_styled_1.PinContent, null,
            react_1.default.createElement(MapRadiusSearch_styled_1.LocationIcon, { name: iconName }),
            react_1.default.createElement(MapRadiusSearch_styled_1.PointName, { className: 'point-name' }, name))));
}
exports.default = PinOfInterest;
//# sourceMappingURL=PinOfInterest.js.map